import TabbedChart from './tabbed-chart';

export default TabbedChart;
